// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3BFd4","modalForm":"UpgradeEpcsModal_modalForm__3Pyfr","modalFooter":"UpgradeEpcsModal_modalFooter__f7mso"};